import { EMPLOYEE_KEYS } from '@/queries/employee/employee.keys';
import { BASE_QUERY_KEYS } from '@/queries/consts';

export const RESOURCES_KEYS = {
  main: 'resources',
  candidates: 'candidates',
  reservations: 'reservations',
  specialists: 'specialists',
  reliefSpecialists: 'reliefSpecialists',
  coordinators: 'coordinators',
  oms: 'oms',
  clinicalLeads: 'clinicalLeads',
  surgeons: 'surgeons',
  contractorSurgeons: 'contractor-surgeons',
  aircrafts: 'aircrafts',
  ocsConsoles: 'ocsConsoles',
  availability: 'availability',
};

export const resourcesQueryKeys = {
  getEmployeesReservations: (...args: unknown[]) =>
    [RESOURCES_KEYS.main, RESOURCES_KEYS.reservations, ...args] as const,
  getCandidatesForAssignments: (...args: unknown[]) =>
    [RESOURCES_KEYS.main, RESOURCES_KEYS.candidates, ...args] as const,
  getCSCandidates: (...args: unknown[]) =>
    [...resourcesQueryKeys.getCandidatesForAssignments(RESOURCES_KEYS.specialists), ...args] as const,
  getReliefCsCandidates: (...args: unknown[]) =>
    [...resourcesQueryKeys.getCandidatesForAssignments(RESOURCES_KEYS.reliefSpecialists), ...args] as const,
  getRSCandidates: (...args: unknown[]) =>
    [...resourcesQueryKeys.getCandidatesForAssignments(RESOURCES_KEYS.surgeons), ...args] as const,
  getCRSCandidates: (...args: unknown[]) =>
    [...resourcesQueryKeys.getCandidatesForAssignments(RESOURCES_KEYS.contractorSurgeons), ...args] as const,
  getCoordinatorCandidates: (...args: unknown[]) =>
    [...resourcesQueryKeys.getCandidatesForAssignments(RESOURCES_KEYS.coordinators), ...args] as const,
  getOMSCandidates: (...args: unknown[]) =>
    [...resourcesQueryKeys.getCandidatesForAssignments(RESOURCES_KEYS.oms), ...args] as const,
  getClinicalLeadCandidates: (...args: unknown[]) =>
    [...resourcesQueryKeys.getCandidatesForAssignments(RESOURCES_KEYS.clinicalLeads), ...args] as const,
  getAvailableResources: (...args: unknown[]) => [RESOURCES_KEYS.main, RESOURCES_KEYS.availability, ...args] as const,
  getAvailableAircrafts: (...args: unknown[]) =>
    [...resourcesQueryKeys.getAvailableResources(RESOURCES_KEYS.aircrafts), ...args] as const,
  getAvailableRS: (...args: unknown[]) =>
    [...resourcesQueryKeys.getAvailableResources(RESOURCES_KEYS.surgeons), ...args] as const,
  getAvailableDevices: (...args: unknown[]) =>
    [...resourcesQueryKeys.getAvailableResources(RESOURCES_KEYS.ocsConsoles), ...args] as const,
  getAvailableEmployee: (...args: unknown[]) =>
    [...resourcesQueryKeys.getAvailableResources(EMPLOYEE_KEYS.main), BASE_QUERY_KEYS.item, ...args] as const,
  getAvailableAircraftsById: (...args: unknown[]) =>
    [...resourcesQueryKeys.getAvailableResources(RESOURCES_KEYS.aircrafts), BASE_QUERY_KEYS.items, ...args] as const,
};
